import React from 'react';
import { useHits } from 'react-instantsearch';
import { Link } from 'gatsby';
import NoResultsBoundary from './NoResultsBoundary';

export default function ProductCollections() {
  const { hits, sendEvent } = useHits();
  return (
      <div className="flex flex-wrap mb-7">
        <p className="text-lg font-bold mx-2 pb-[7px] w-full">Categories</p>
        <NoResultsBoundary fallback={<p className="mx-2 mt-3 mb-2 text-sm">No categories found</p>}>
          {hits.map((hit) => (
              <Link
                  onClick={() => sendEvent('click', hit, 'Collection clicked')}
                  onAuxClick={() => sendEvent('click', hit, 'Collection clicked')}
                  key={hit.objectID}
                  to={`/collections/${hit.objectID}`}
                  className="w-1/2 underline underline-offset-4 text-sm lg:text-[15px] h-9 p-2 box-border flex items-center"
              >
                {hit.title}
              </Link>
          ))}
        </NoResultsBoundary>
      </div>
  );
}
